import { render, staticRenderFns } from "./TitleDeedInfo.vue?vue&type=template&id=1c61c7d0&"
import script from "./TitleDeedInfo.vue?vue&type=script&lang=js&"
export * from "./TitleDeedInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports